<template>
    <div>
        <div v-if="error">
            <p>There was an error loading the map request form. Please contact us if this issue persists.</p>
        </div>

        <div v-if="!loaded">
            <p>Loading available reports.</p>
        </div>

        <div v-else>
            <div v-if="responseReceived" v-for="(responseMessage, index) in responseMessages">
                <div v-if="responseMessage.success">
                    <div class="success">
                        <div class="message alert alert-success mb-4 mt-4">
                            <div>
                                <p>Request sent! You should receive your report shortly. If not received, check your spam folder. Please note sometimes technical difficulties may delay the delivery of your report. If you haven't received your report after 24 hours, please contact <a href="https://www.nrmmrrd.qld.gov.au/contact-us#vegetation-management">support</a>.</p>
                            </div>
                            <!-- <div v-if="(index ===  0)">
                                
                                <div v-if="responseMessage.MapName[0] === 'ALLVEG' ">
                                    <p>Report Name: Vegetation management report</p>
                                </div>
                                <div v-else-if="responseMessage.MapName[0] === 'VEG1' ">
                                    <p>Report Name: Regulated Vegetation Management Map</p>
                                </div>
                                <div v-else-if="responseMessage.MapName[0] === 'PRECLEAR' ">
                                    <p>Report Name: Vegetation Management Pre-Clear Regional Ecosystem Map</p>
                                </div>
                            </div>
                            <div v-if="(index ===  1)">
                                
                                <div v-if="responseMessage.MapName[1] === 'ALLVEG' ">
                                    <p>Report Name: Vegetation management report</p>
                                </div>
                                <div v-else-if="responseMessage.MapName[1] === 'VEG1' ">
                                    <p>Report Name: Regulated Vegetation Management Map</p>
                                </div>
                                <div v-else-if="responseMessage.MapName[1] === 'PRECLEAR' ">
                                    <p>Report Name: Vegetation Management Pre-Clear Regional Ecosystem Map</p>
                                </div>
                            </div>
                            <div v-if="(index ===  2)">
                                
                                <div v-if="responseMessage.MapName[2] === 'ALLVEG' ">
                                    <p>Report Name: Vegetation management report</p>
                                </div>
                                <div v-else-if="responseMessage.MapName[2] === 'VEG1' ">
                                    <p>Report Name: Regulated Vegetation Management Map</p>
                                </div>
                                <div v-else-if="responseMessage.MapName[2] === 'PRECLEAR' ">
                                    <p>Report Name: Vegetation Management Pre-Clear Regional Ecosystem Map</p>
                                </div>
                            </div>
                            
                            <p>Location: {{ responseMessage.location }}</p>
                            <p>{{ responseMessage.statusMessage }}</p> -->
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="warn">
                        <div class="message alert alert-warning mb-4 mt-4">
                            <p v-if="responseMessage.location">Location: {{ responseMessage.location }}</p>
                            <p>{{ responseMessage.statusMessage }}</p>
                            <template v-for="reportRequest in  requestedReports">
                                {{ reportRequest }}
                            </template>
                            <template v-if="responseMessage.outputMessages.length > 0">
                                <p>Details:</p>
                                <ul>
                                    <li v-for="outputMessage in responseMessage.outputMessages">{{ outputMessage }}</li>
                                </ul>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="formErrors.length > 0">
                <div class="warn">
                    <div class="message alert alert-warning mb-4 mt-4">
                        <p>Your request has the following error(s):</p>
                        <ul>
                            <li v-for="formError in formErrors">{{ formError }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <form id="vm-req-form" v-if="!error" @submit.prevent="">
                <fieldset>
                    <legend>Select up to 10 properties per map type:</legend>
                    <div v-for="reports in reportsAvailable">
                        <div class="form-check checkbox">
                            <input class="form-check-input" :id="reports.key" type="checkbox" name="report-types" :value="reports.key" v-model.trim="requestedReports"
                                   @change="requestType()">
                            <label class="form-check-label" :for="reports.key">{{ reports.name }}<br><small>{{ reports.description }}</small></label>
                        </div>
                    </div>
                </fieldset>

                <div v-if="locationTypeSelector" class="mb-1">

                    <fieldset>
                        <legend>Specify map location by</legend>
                        <div class="form-check radio">
                            <input class="form-check-input"  id="point" type="radio" name="location-types" value="point" v-model.trim="locationType">

                            <label class="form-check-label" for="point">Coordinates</label>
                        </div>
                        <div class="form-check radio">
                            <input class="form-check-input" id="lot-plan" type="radio" name="location-types" value="LotPlan" v-model.trim="locationType">
                            <label class="form-check-label" for="lot-plan">Lot/plan</label>

                        </div>
                    </fieldset>
                </div>

                <div v-if="locationType === 'LotPlan' && requestedReports.length > 0">
                    <hr>
                    <fieldset>
                        <div class="lot-plan d-flex gap-4 mb-4" v-for="(lotPlan, index) in lotPlans">
                            <div class="row w-100">
                            <div class="group lot col-6 d-flex flex-column justify-content-between">
                                
                                <div class="mb-0">
                                    <label class="qld-text-input-label field-required" :for="'lot-number-' + index">Lot number</label>
                                    <span class="qld-hint-text">Enter the lot only, do not include L or lot in front. <br>
                                    (e.g. 57 or D)
                                    </span>
                                </div>
                                    <input type="text" required class="lotNumber form-control" name="lot-number" :id="'lot-number-' + index" v-model.trim="lotPlan.lot"
                                       autocomplete="off">
                                <!--                <div class="error">{{formErrors[0]}}</div>-->
                                <!--                <div class="error" v-if="formErrors.indexOf(lotError)">Field is required</div>-->
                                

                            </div>


                            <div class="group plan col-6 d-flex flex-column justify-content-between">

                                  <div class="mb-0">
                                    <label class="qld-text-input-label field-required" :for="'plan-number-' + index">Plan number</label>
                                    <span class="qld-hint-text">Enter the plan only. </br>(e.g. RP2 or AG1234)</span>
                                   
                                  </div>

                                
                                
                                <input class="planNumber form-control" type="text" required name="plan-number" :id="'plan-number-' + index" v-model.trim="lotPlan.plan" autocomplete="off">
                                <!--                <div class="error">{{formErrors[1]}}</div>-->
                            </div>
                            </div>
                            <div class="align-self-end">
                                <button style="min-width: 10%;" v-if="lotPlans[0].lot !== '' && lotPlans[0].plan" id="remove-lotplan" @click="removeLotPlan(index)" type="button"
                                        class="close btn btn-secondary" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        
                        <button class="btn btn-secondary" v-if="lotPlans[0].lot !== '' && lotPlans[0].plan" id="add-lotplan" type="button" @click="addLotPlan">Add another location</button>
                        <div class="alert alert-danger mt-3" id="hide-lotplan-alert" style="display:none">
                            <p style="margin-bottom: 0">Enter at least one set of lot on plan details or coordinates</p>
                        </div>
                    </fieldset>
                </div>

                <div v-if="locationType === 'point' && requestedReports.length > 0">
                    <hr>
                    <fieldset>
                        <div class="coordinates d-flex gap-4 mb-4" v-for="(point, index) in coordinates">
                            <div class="row w-100">
                                <div class="group lat col-6 d-flex flex-column justify-content-between">
                                    
                                    <div class="mb-0">
                                        <label class="qld-text-input-label field-required" :for="'lat-' + index">Latitude</label>
                                        <span class="qld-hint-text">In decimal degrees, e.g. -17.286001</span>
                                    </div>
                                    
                                    <input type="text" required class="latNumber form-control" name="lat" :id="'lat-' + index" v-model.trim="point.lat"
                                        autocomplete="off">
                                </div>


                                <div class="group lng col-6 d-flex flex-column justify-content-between">
                                    
                                    <div class="mb-0">
                                        <label class="qld-text-input-label field-required" :for="'lng-' + index">Longitude</label>
                                        <span class="qld-hint-text">In decimal degrees, e.g. 145.573891</span>
                                    </div>
                                    
                                    <input type="text" required class="lngNumber form-control" name="lng" :id="'lng-' + index" v-model.trim="point.lng"
                                        autocomplete="off">
                                </div>
                            </div>
                            <div class="align-self-end">
                                <button style="min-width: 10%;" v-if="coordinates[0].lat !== '' && coordinates[0].lng" id="remove-coordinates" @click="removeCoordinates(index)"
                                        type="button" class="close btn btn-secondary" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        
                        
                        <button class="btn btn-secondary" v-if="coordinates[0].lat !== '' && coordinates[0].lng" id="add-coordinates" type="button" @click="addCoordinates">Add another location
                        </button>
                        <div class="alert alert-danger mt-3" id="hide-coordinates-alert" style="display:none">
                            <p style="margin-bottom: 0">Enter at least one set of lot on plan details or coordinates</p>
                        </div>
                    </fieldset>
                </div>

                <div
                    v-if="requestedReports.length > 0 && (lotPlans[0].lot !== '' && lotPlans[0].plan !== '' || coordinates[0].lat !== '' && coordinates[0].lng !== '')">
                    
                    <hr>

                    <div class="email mt-4 mb-4">
                        <label class="qld-text-input-label field-required"  for="email">Email</label>
                        <input type="email" required class="emailAddress form-control" name="email" id="email" v-model.trim="emailAddress" autocomplete="off">
                        <!--            <div class="error">{{formErrors[2]}}</div>-->
                    </div>

                    <strong>
                        <button class="btn btn-primary" @click="requestMap()">Request map</button>
                    </strong>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
// Imports
import axios from 'axios'

export default {
    data: function () {
        return {
            reportTypes: ['ALLVEG', 'VEG1', 'PRECLEAR'],
            reportTypesName: ['', '', ''],
            reportsAvailable: [],
            requestedReports: [],
            locationTypeSelector: false,
            locationType: '',
            requestsType: [],
            reportTypesResponse: [],

            lotPlans: [{
                lot: '',
                plan: ''
            }],
            coordinates: [{
                lat: '',
                lng: ''
            }],

            emailAddress: null,
            formErrors: [],
            responseMessages: [],
            responseReceived: false,
            error: false,
            loaded: false,

        };
    },
    methods: {
        requestType: function () {
            let vm = this;

            if (vm.requestedReports.length === 1 && vm.requestedReports.includes('VEG1')) {
                vm.locationTypeSelector = true;
            } else {
                vm.locationTypeSelector = false;
                vm.locationType = 'LotPlan';
            }
        },
        mapOrder: function (array, order, key) {

            // Sort an object based off another array. Used to sort the response from the map service available reports in the order we specify.
            array.sort(function (a, b) {
                var A = a[key], B = b[key];

                if (order.indexOf(A) > order.indexOf(B)) {
                    return 1;
                } else {
                    return -1;
                }
            });

            return array;
        },
        addLotPlan: function (index) {
            let vm = this;

            // Add the lot/plan to the array.
            vm.lotPlans.push({lot: '', plan: ''});

            // Check that there are no more than 10 lot/plan pairs in the array. If there are, hide the "Add another location" link.
            if (vm.lotPlans.length === 10) {
                var addLocationButton = document.getElementById('add-lotplan');
                addLocationButton.style.display = 'none';
            }
            //remove remove button from the first item
            if (index === 1) {
                var removeLocationButton = document.getElementById('remove-lotplan');
                removeLocationButton.style.display = 'none';
            }
            if (vm.lotPlans.length > 1) {
                $('#hide-lotplan-alert').slideUp("slow");
            }
        },
        removeLotPlan: function (index) {
            let vm = this;
            // Add the lot/plan to the array.
            if (vm.lotPlans.length > 1) {
                vm.lotPlans.splice(index, 1);
            } else {
                $('#hide-lotplan-alert').slideDown("slow");
            }
            if (vm.lotPlans.length < 10) {
                var removeLocationButton = document.getElementById('add-lotplan');
                removeLocationButton.style.display = 'block';
            }
        },
        addCoordinates: function (index) {
            let vm = this;

            vm.coordinates.push({lat: '', lng: ''});

            if (vm.coordinates.length === 10) {
                var addLocationButton = document.getElementById('add-coordinates');
                addLocationButton.style.display = 'none';
            }
            //remove remove button from the first item
            if (index === 1) {
                var removeCoordinatesButton = document.getElementById('remove-coordinates');
                removeCoordinatesButton.style.display = 'none';
            }
            if (vm.coordinates.length > 1) {
                $('#hide-coordinates-alert').slideUp("slow");
            }
        },
        removeCoordinates: function (index) {
            let vm = this;
            // Add the lot/plan to the array.
            if (vm.coordinates.length > 1) {
                vm.coordinates.splice(index, 1);
            } else {
                $('#hide-coordinates-alert').slideDown("slow");
            }
            if (vm.coordinates.length < 10) {
                var addLocationButton = document.getElementById('add-coordinates');
                addLocationButton.style.display = 'block';
            }
        },
        validateEmail: function (email) {

            // Set the regex to compare email address.
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        getAllData: function (URLs) {
            return Promise.all(URLs.map(this.fetchData));
        },
        fetchData: function (URL) {
            return axios
                .get(URL)
                .then(function (response) {
                    return {
                        data: response.data
                    };
                })
                .catch(function (error) {
                    console.dir(error);
                    return {
                        success: false
                    };
                });
        },
        addErrorInputHighlight: function (elementName) {
            elementName.style.color = "red";
            elementName.style.borderColor = 'red';
        },
        removeErrorInputHighlight: function (elementName) {
            elementName.style.color = "black";
            elementName.style.borderColor = 'rgb(238,238,238)';
        },
        requestMap: function () {

            let vm = this;

            // URL of map service, used to build the entire request.
            let mapService = 'https://mapsonline.information.qld.gov.au/service/environment/resource/MapsOnline/1/http/rest/request?';

            // To hold the query strings for each map type and location.
            let query;

            // Hold all the queries together so we can call them one by one.
            let queryList = [];

            // Reset the response messages array in case they've previously submitted this form.
            vm.responseMessages = [];

            // Reset the error messages array in case they've previously submitted this form.
            vm.formErrors = [];

            // Set the error message text.
            var missingLotPlan = 'Your request is missing some information. Please check the lot/plan you\'ve specified.';
            var missingCoords = 'Your request is missing some information. Please check the coordinates you\'ve specified.';
            var lotError = 'Only letters and numbers are allowed when specifying the lot.';
            var planError = 'Only letters and numbers are allowed when specifying the plan.';
            var coordsError = 'Only numbers are allowed when specifying coordinates.';
            var emailError = 'The email address you\'ve entered is not valid.';


            var lotNumbers = document.querySelectorAll(".lotNumber");

            var planNumbers = document.querySelectorAll(".planNumber");

            var emailAddress = document.getElementsByClassName("emailAddress")[0];

            var latNumbers = document.querySelectorAll(".latNumber");
            var lngNumbers = document.querySelectorAll(".lngNumber");


            // Loop through each report type.
            vm.requestedReports.forEach(function (key) {

                // If the location type was last set to lot/plan, loop through each lot/plan specified. Note: this must be done here since the coordinates obj could still have data.
                if (vm.locationType === 'LotPlan') {
                    vm.lotPlans.forEach(function (index) {
                        if (index.lot !== '' && index.plan !== '') {

                            // Remove whitespace from lot number.
                            index.lot = index.lot.replace(/ /g, '');

                            // Lot can only contain numbers.
                            //let re = /[^0-9]/g;
                            //let re = /^([a-z]{2})?([0-9]+)$/ig;
                            let re = /[^\w]|_/g;
                            //let vm = this;
                            //var nre = /^\d+$/;
                            //var lotNumber = jQuery('.lot-number');

                            if (re.test(index.lot)) {
                                // Make sure this error doesn't already exist in the error array.
                                if (vm.formErrors.indexOf(lotError) === -1) {
                                    vm.formErrors.push(lotError);
                                    // var addLocationButton = document.getElementById('add-coordinates');
                                }
                                //exclude first lot plan
                            }
                            for (const lotNumber of lotNumbers) {
                                if (lotNumber.value.match(re)) {
                                    vm.addErrorInputHighlight(lotNumber);
                                } else if (!lotNumber.value.match(re) && lotNumber.value !== '') {
                                    vm.removeErrorInputHighlight(lotNumber);
                                }
                            }

                            // Remove whitespace from plan number.
                            index.plan = index.plan.replace(/ /g, '').toUpperCase();

                            // Plan can only contain letters and numbers.
                            let pre = /[^\w]|_/g;


                            if (pre.test(index.plan)) {

                                // Make sure this error doesn't already exist in the error array.
                                if (vm.formErrors.indexOf(planError) === -1) {
                                    vm.formErrors.push(planError);
                                }
                            }
                            for (const planNumber of planNumbers) {
                                if (planNumber.value.match(pre)) {
                                    vm.addErrorInputHighlight(planNumber);
                                } else if (!planNumber.value.match(pre) && planNumber.value !== '') {
                                    vm.removeErrorInputHighlight(planNumber);
                                }
                            }

                            query = 'reportType=' + key + '&featureType=LotPLan&features=' + index.lot + ',' + index.plan + '&emailAddress=' + vm.emailAddress;

                            // Add entire query and the report name to the array.
                            queryList.push(mapService + query);
                        } else {
                            // Either a lot/plan hasn't been entered. Make sure this error doesn't already exist in the error array.
                            if (vm.formErrors.indexOf(missingLotPlan) === -1) {
                                vm.formErrors.push(missingLotPlan);
                            }
                            for (const lotNumber of lotNumbers) {
                                //let re = /[^0-9]/g;
                                //let re = /^([a-z]{2})?([0-9]+)$/ig;
                                let re = /[^\w]|_/g;
                                if (lotNumber.value === '') {
                                    vm.addErrorInputHighlight(lotNumber);
                                } else if (!lotNumber.value.match(re) && lotNumber.value === '') {
                                    vm.removeErrorInputHighlight(lotNumber);
                                }

                            }
                            for (const planNumber of planNumbers) {
                                let pre = /[^\w]|_/g;
                                if (planNumber.value === '') {
                                    vm.addErrorInputHighlight(planNumber);
                                } else if (!planNumber.value.match(pre) && planNumber.value === '') {
                                    vm.removeErrorInputHighlight(planNumber);
                                }

                            }
                        }


                    });
                }

                // If the location type was last set to point, loop through each lat/lng specified.
                if (vm.locationType === 'point') {
                    vm.coordinates.forEach(function (index) {

                        if (index.lat !== '' && index.lng !== '') {

                            // Remove whitespace from both coordinates.
                            index.lat = index.lat.replace(/ /g, '');
                            index.lng = index.lng.replace(/ /g, '');

                            //let re = /[^0-9]/g;
                            let re = /^(\d*\.)?\d+$/;
                            // var regex = new Regex(@"^-?[0-9][0-9,\.]+$");
                            // Numbers, periods, hyphens only.
                            if (isNaN(index.lat)) {
                                // Make sure this error doesn't already exist in the error array.
                                if (vm.formErrors.indexOf(coordsError) === -1) {
                                    vm.formErrors.push(coordsError);
                                }
                            }
                            for (const latNumber of latNumbers) {
                                if (isNaN(latNumber.value)) {
                                    vm.addErrorInputHighlight(latNumber);
                                } else if (!isNaN(latNumber.value) && latNumber.value !== '') {
                                    vm.removeErrorInputHighlight(latNumber);
                                }
                            }

                            if (isNaN(index.lng)) {
                                // Make sure this error doesn't already exist in the error array.
                                if (vm.formErrors.indexOf(coordsError) === -1) {
                                    vm.formErrors.push(coordsError);
                                }
                            }
                            for (const lngNumber of lngNumbers) {
                                if (isNaN(lngNumber.value)) {
                                    vm.addErrorInputHighlight(lngNumber);
                                } else if (!isNaN(lngNumber.value) && lngNumber.value !== '') {
                                    vm.removeErrorInputHighlight(lngNumber);
                                }
                            }
                            query = 'reportType=' + key + '&featureType=point&features=' + index.lat + ',' + index.lng + '&emailAddress=' + vm.emailAddress;

                            // Add entire query and the report name to the array.
                            queryList.push(mapService + query);
                        } else {
                            // Either a lat/long hasn't been entered. Make sure this error doesn't already exist in the error array.
                            if (vm.formErrors.indexOf(missingCoords) === -1) {
                                vm.formErrors.push(missingCoords);
                            }
                            for (const latNumber of latNumbers) {
                                if (latNumber.value === '') {
                                    vm.addErrorInputHighlight(latNumber);
                                } else if (!isNaN(latNumber.value) && latNumber.value === '') {
                                    vm.removeErrorInputHighlight(latNumber);
                                }
                            }
                            for (const lngNumber of lngNumbers) {
                                if (lngNumber.value === '') {
                                    vm.addErrorInputHighlight(lngNumber);
                                } else if (!isNaN(lngNumber.value) && lngNumber.value === '') {
                                    vm.removeErrorInputHighlight(lngNumber);
                                }
                            }
                        }
                    });
                }
            });

            // Check if the email address is valid.
            if (!vm.validateEmail(vm.emailAddress)) {
                if (vm.formErrors.indexOf(emailError) === -1) {
                    vm.formErrors.push(emailError);
                }
                vm.addErrorInputHighlight(emailAddress);
            } else if (vm.validateEmail(vm.emailAddress)) {
                vm.removeErrorInputHighlight(emailAddress);
            }

            // If there are errors with the input values, return the form.
            if (vm.formErrors.length > 0) {
                // console.log(Object.keys(vm.formErrors))
                // console.log(vm.formErrors.indexOf(emailError));
                return;
            }

            vm.getAllData(queryList).then(function (responses) {
                responses.forEach(function (response) {
                    console.log(response);
                    if (!response.data) {
                        throw 'error';
                    }
                    vm.responseMessages.push({
                        success: response.data.success,
                        statusMessage: response.data.message,
                        outputMessages: response.data.output,
                        MapName: vm.requestedReports,
                      //  location: response.data.field_validations[0].values.features[0] + ' ' + response.data.field_validations[0].values.features[1]
                    });
                });

                // Reset form fields. (Email is ok to keep.)
                vm.requestedReports = [];
                vm.locationTypeSelector = false;
                vm.locationType = '';
                vm.lotPlans = [{
                    lot: '',
                    plan: ''
                }];
                vm.coordinates = [{
                    lat: '',
                    lng: ''
                }];
            }).catch(function (e) {
                vm.responseMessages.push({
                    success: true,
                    statusMessage: 'We are currently experiencing a technical issue. Please try again later.',
                    outputMessages: [],
                    MapName: vm.requestedReports
                })
            }).finally(function () {
                window.scrollTo(0, 0);
                vm.responseReceived = true;
            });
        }
    },
    mounted: function () {
        let vm = this;
        axios
            .get('https://mapsonline.information.qld.gov.au/service/environment/resource/MapsOnline/1/http/rest/getReportTypes')
            .then(function (response) {

                // Create an array to hold the formatted response.
                response.data.output.forEach(function (i) {
                    // Add the name and description for each report type specified.
                    if (vm.reportTypes.includes(i.type)) {
                        vm.reportTypesResponse.push({name: i.name, key: i.type, description: i.description})
                    }
                });
                // console.log(vm.reportTypesResponse);
                // Order the response based off our list and assign it to the variable for output.
                vm.reportsAvailable = vm.mapOrder(vm.reportTypesResponse, vm.reportTypes, 'key');
            })
            .catch(function (error) {
                console.dir(error);
                vm.error = true;
            })
            .finally(function () {
                vm.loaded = true;
            });
    }
}
</script>

<style>
#map-request fieldset {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
}

#map-request .lot-plan,
#map-request .coordinates {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}

#map-request .lot-plan .group,
#map-request .coordinates .group {
    flex: 1;
    display: flex;
    flex-direction: column;
}

#map-request .lot-plan > div,
#map-request .coordinates > div {
    margin-right: 1%;
}

#map-request .lot-plan .group input,
#map-request .coordinates .group input {
    margin-top: auto;
}

#map-request .email {
    padding: 20px 0;
}

#map-request .email label {
    display: block;
}

#map-request .email input {
    width: 100%;
}

#map-request .success,
#map-request .warn {
    margin: 0 0 10px;
    padding: 20px;
    display: flex;
}

#map-request .success .message h3,
#map-request .warn .message h3 {
    margin-top: 0;
}

.close:hover {
    color: #000;
    text-decoration: none;
    background: transparent;
    outline: none;
}

.lot-plan:nth-child(1) #remove-lotplan,
.coordinates:nth-child(1) #remove-coordinates {
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// App.vue?23c49ca4